import { TableColumnProps } from "antd";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import { getMasterRepairshopList } from "../../../../apis/master";
import useUser from "../../../../hooks/useUsers";
import { RepairShop } from "../../../../model/RepairShop";
import { getDecodeToken } from "../../../../shared/utils/Token";
import { TableForm } from "../../Table";

export const RepairShopList = () => {
  const queryClient = useQueryClient();
  const { getUserID } = useUser();

  const info = getDecodeToken();

  const { data, refetch } = useQuery(
    "repairShopList",
    getMasterRepairshopList,
    {
      enabled: info?.isMaster && !queryClient.getQueryData("repairShopList"),
      select: (data) => data.filter((row) => row.id !== getUserID()),
    }
  );

  const columns: TableColumnProps<RepairShop>[] = [
    {
      title: "No.",
      key: "index",
      dataIndex: "id",
      align: "center",
      width: "5%",
      render: (value) =>
        (data?.findIndex((row) => row.id === value) as number) + 1,
    },
    {
      title: "매장 코드",
      key: "repairshopCode",
      dataIndex: "repairShopCode",
      align: "center",
      width: "15%",
    },
    {
      title: "상호명",
      key: "displayName",
      dataIndex: "displayName",
      width: "20%",
    },
    {
      title: "담당자명",
      key: "managerName",
      dataIndex: "managerName",
      align: "center",
      width: "15%",
    },
    { title: "매장 주소", key: "zibun", dataIndex: "zibun", width: "30%" },
    {
      title: "매장 대표번호",
      key: "managerPhone",
      dataIndex: "managerPhone",
      align: "center",
      width: "15%",
    },
  ];

  useEffect(() => {
    refetch();
  }, []);

  return (
    <TableForm
      columns={columns}
      dataSource={data}
      pagination={false}
      scroll={{ y: 430 }}
      size="middle"
    />
  );
};
